import styles from '@ui/components/Voting/components/IntroImage/IntroImage.module.scss';
import CardImage from '@ui/components/Card/components/CardImage/CardImage';
import Image from '@ui/components/Image/Image';
import React from 'react';
import PropTypes from 'prop-types';

const IntroImage = ({ images }) => {
  // do not render anything if no images have been set
  if (!Array.isArray(images) || images?.length === 0) {
    return null;
  }

  if (images.length === 1) {
    return <CardImage aspectRatio={0.5625} image={images[0]} />;
  }

  // toggle type can have up to two images
  return (
    <div className={styles.container}>
      {images?.map(image => (
        <Image
          className={styles.toggleImage}
          id={image.id}
          key={image.id}
          {...image}
        />
      ))}
    </div>
  );
};

IntroImage.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string,
      src: PropTypes.string.isRequired,
      srcSet: PropTypes.string,
    }),
  ),
};

export default IntroImage;
